export default "__VITE_ASSET__yfawMfSR__"